export const DASHBOARD_ENDPOINT = 'user/dashboard';
